// resetPasswordValidation.js
import { VALIDATION_MESSAGES } from '../../../../utils/constants/ValidationMessagesConstants';

function validateResetPassword(password, confirmPassword) {
    if (password === '' || password === undefined) {
        return {
            passwordErr: true,
            passwordErrMessage: VALIDATION_MESSAGES.PASSWORD_BLANK,
        };
    } else if (password.search(/^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,20}$/) < 0) {
        return {
            passwordErr: true,
            passwordErrMessage: VALIDATION_MESSAGES.PASSWORD_TYPE,
        };
    } else {
        return {
            passwordErr: false,
            passwordErrMessage: '',
        };
    }
}

export default validateResetPassword;
